import { useQuery } from '@tanstack/react-query';
import { getMealDates } from '../../../api/diary-service';

/**
 * Hook to fetch all dates where the user has meal entries.
 */
const useMealDates = (from = null, to = null, mealType = null) => {
    return useQuery({
        queryKey: ['mealDates', from, to, mealType],
        queryFn: () => getMealDates(from, to, mealType),
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
        retry: 1,
        onError: (error) => {
            console.error('Failed to fetch meal dates:', error);
        }
    });
};

export default useMealDates;
